/**
 * TypeScript interfaces for scheduling skill configuration
 */

export interface SchedulingSkillConfig {
  enabled: boolean;
  booking_type: 'Calendly' | 'Manual';
  scheduling_link?: string;
  instructions?: string;
}

// Type guard to check if an object is a valid SchedulingSkillConfig
export function isSchedulingSkillConfig(obj: any): obj is SchedulingSkillConfig {
  if (!obj || typeof obj !== 'object') return false;
  
  return (
    typeof obj.enabled === 'boolean' &&
    (obj.booking_type === 'Calendly' || obj.booking_type === 'Manual') &&
    (obj.scheduling_link === undefined || typeof obj.scheduling_link === 'string') &&
    (obj.instructions === undefined || typeof obj.instructions === 'string')
  );
}

// Helper function to safely parse skills_scheduling from Json
export function parseSchedulingConfig(jsonData: any): SchedulingSkillConfig | null {
  if (!jsonData) return null;
  
  // If it's already an object, validate it
  if (typeof jsonData === 'object' && isSchedulingSkillConfig(jsonData)) {
    return jsonData;
  }
  
  // If it's a string, try to parse it
  if (typeof jsonData === 'string') {
    try {
      const parsed = JSON.parse(jsonData);
      if (isSchedulingSkillConfig(parsed)) {
        return parsed;
      }
    } catch {
      // Invalid JSON, return null
    }
  }
  
  return null;
} 